import { FormTextInputPdfEditor } from '../text-input/FormTextInputPrintPdfEditor'

export const FormNumericInputPdfEditor = (props) => {
  return <FormTextInputPdfEditor {...props} />
}
